import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  debounceTime,
  distinctUntilChanged,
  startWith,
  tap,
  delay,
} from 'rxjs/operators';
import { merge, fromEvent } from 'rxjs';
import { MemberDataService } from '../../services/member-data.service';
import { MemberInfo } from '../../models/MemberInfo';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MemberDetailComponent } from '../member-detail/member-detail.component';
import { LoggingService } from 'src/app/utilities/logging.service';
import { AlertDialogComponent } from 'src/app/glp-common/components/alert-dialog/alert-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { DeniedDialogComponent } from 'src/app/glp-common/components/denied-dialog/denied-dialog.component';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { TelementryService } from 'src/app/services/telemetry.service';
import { ActivityType } from 'src/app/models/ActivityType';
import { getPortalVersion, PortalVersion } from 'src/app/portal-config';

@Component({
  standalone: false,
  selector: 'app-members-list',
  templateUrl: './members-list.component.html',
  styleUrls: ['./members-list.component.scss'],
})
export class MembersListComponent implements OnInit {
  groupId: string;
  selectedMemberId: number;
  enableSearch: boolean;
  idType:string;
  isGroup:boolean;
  coverageType:string;

  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
    'memberId',
    // 'accountId',
    'name',
    'dateOfBirth',
    'coverageType',
    'coverageStart',
    'coverageEnd',
    'dependent',
    'status'
    // 'planVersionEffectiveThruDt',
  ];

  filterStr: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private dataService: MemberDataService,
    private dialog: MatDialog,
    private loggingService: LoggingService,
    private userService: UserService,
    private telementryService: TelementryService,
    public auth: AuthService,
  ) {}

  ngOnInit() {
    const errorDialogConfig = new MatDialogConfig();

    this.groupId = this.dataService.selectedGroupID;

    if(this.groupId == undefined || this.groupId == null)
    {
      this.groupId = this.userService.user.accountNumber;
    }

    //default idType is groupId
    if(this.dataService.idType == undefined || this.dataService.idType == null){
      this.idType = 'groupId';
    }
    else{
      this.idType = this.dataService.idType;
    }

    //when called by Individual List, search by subscriberId
    if(this.idType == 'individualId'){
      //this.groupId = Number(this.dataService.selctedSubscriber);
      this.isGroup = false;
      this.coverageType = this.dataService.productType;
    }
    else{
      this.isGroup = true;
    }


    this.dataService.getMemberList(this.groupId, this.userService.user.email, this.idType, this.coverageType, this.dataService.selctedSubscriber).subscribe((list) => {

      if (list == null || list.length <= 0)
      {
        errorDialogConfig.data = {
          title: 'No Members found',
          message: 'No members were found for this group. Please try again later.',
          footermessage: '',
        };
        var err = {
          name: 'Members List is empty',
          message: 'Members List is empty = ' + this.userService.user.accountNumber,
          stack: 'Members List is empty',
        };
        this.loggingService.logException(err, 3);

        this.dialog.open(DeniedDialogComponent, errorDialogConfig);
        let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
        this.dialog.afterAllClosed.subscribe((_) => this.auth.logout({ logoutParams: { returnTo: logoutUrl } }));
      }

      this.enableSearch = true;

      let array = list.map((item) => {
        return {
          $key: item.memberId,
          ...item,
        };
      });
        this.dataSource = new MatTableDataSource(array);
      this.dataSource.filterPredicate = (data, filter) => {
        this.applyFilter(this.filterStr);
        return this.displayedColumns.some((ele) => {
          return data[ele].toLowerCase().indexOf(filter) != -1;
        });
      };
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'coverageStart': return new Date(item.coverageStart);
          case 'coverageEnd': return new Date(item.coverageEnd);
          case 'dateOfBirth': return new Date(item.dateOfBirth);
          default: return item[property];
        }
      };
      this.dataSource.paginator = this.paginator;
    },
    (error) => {
      if(error.status == 400){
        errorDialogConfig.data = {
          title: 'Invalid Group Information provided',
          message: 'The Group Information provided is either not associated with this broker or we are having trouble finding it. Please try again later.',
          footermessage: '',
        };
        var err = {
          name: 'Invalid Group Information provided',
          message: 'Invalid Group Information provided = ' + this.userService.user.accountNumber,
          stack: 'Invalid Group Information provided',
        };
        this.loggingService.logException(err, 3);

        this.dialog.open(DeniedDialogComponent, errorDialogConfig);
        let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
        this.dialog.afterAllClosed.subscribe((_) => this.auth.logout({ logoutParams: { returnTo: logoutUrl } }));
      }
      if(error.status == 500){
        errorDialogConfig.data = {
          title: 'Error retrieving members',
          message: 'We are currently having trouble retrieving group members. Please try again later.',
          footermessage: '',
        };
        var err = {
          name: 'Error retrieving members',
          message: 'Error retrieving members = ' + this.userService.user.accountNumber,
          stack: 'Error retrieving members',
        };
        this.loggingService.logException(err, 3);

        this.dialog.open(DeniedDialogComponent, errorDialogConfig);
        let logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
        this.dialog.afterAllClosed.subscribe((_) => this.auth.logout({ logoutParams: { returnTo: logoutUrl } }));        
      }
    });
  }

  applyFilter(filterValue: string) {
      this.filterStr = filterValue.trim();
      if(this.dataSource)
      {
      if (filterValue.trim() != "")
      {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filterPredicate = (data: any, filter: string) => {

        var c1 = (typeof data.memberId !== 'undefined' && data.memberId !== null && data.memberId.includes(filter) ||
                 (typeof data.name !== 'undefined' && data.name !== null && data.name.toLowerCase().includes(filter)) ||
                 (typeof data.dateOfBirth !== 'undefined' && data.dateOfBirth !== null && data.dateOfBirth.includes(filter)) ||
                 (typeof data.coverageType !== 'undefined' && data.coverageType !== null && data.coverageType.toLowerCase().includes(filter)) ||
                 (typeof data.coverageStart !== 'undefined' && data.coverageStart !== null && data.coverageStart.includes(filter)) ||
                 (typeof data.coverageEnd !== 'undefined' && data.coverageEnd !== null && data.coverageEnd.includes(filter)) ||
                 (typeof data.dependent !== 'undefined' && data.dependent !== null && data.dependent.toLowerCase().includes(filter)) ||
                 (typeof data.status !== 'undefined' && data.status !== null && data.status.toLowerCase().includes(filter))
        );

        return c1;
        };
        this.dataSource.filter = filterValue;
      }

        this.dataSource.filter = filterValue;
      }
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event) {
    // This method will be called when the user clicks the back button
    console.log('Back button clicked');
    this.userService.setGroupLeaderAccountIsSelected(false);
  }

  clickFilter() {
    this.dataSource.filter = this.searchInput.nativeElement.value.trim().toLowerCase();
    this.telementryService.trackSentryFeature(ActivityType.MemberSearch);
  }

  openDetails(row: any) {
    this.telementryService.trackSentryFeature(ActivityType.MemberView);
    this.selectedMemberId = row.memberId;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minWidth = '45%';
    dialogConfig.minHeight = '75%';
    dialogConfig.data = row;
    dialogConfig.position = { right: '0px', top: '25px' };
    dialogConfig.panelClass = 'mat-dialog-member-details-container';
    this.dialog.open(MemberDetailComponent, dialogConfig);
  }

  ts_map = {
    "Member Id": "descending",
    "Account Id": "descending",
    "Name": "ascending",
    "Date Of Birth": "descending",
    "Coverage Type": "descending",
    "Coverage Start": "descending",
    "Coverage End": "descending",
    "Dependent": "descending"
  }

 toggleSortingOrder(key: string) {
    if (key in this.ts_map) {
      for (const k in this.ts_map) {
        if (k !== key) {
          this.ts_map[k] = "descending";
        }
      }
      if (this.ts_map[key] === "descending") {
        window.dataLayer.push({'event': 'broker_click', 'click_location':'Members Table', 'click_action': `Table Header - ${key} - ascending`});
        this.ts_map[key] = "ascending";
      } else {
        window.dataLayer.push({'event': 'broker_click', 'click_location':'Members Table', 'click_action': `Table Header - ${key} - descending`});
        this.ts_map[key] = "descending";
      }
      this.telementryService.trackSentryFeature(ActivityType.ToggleSortingOrder, {
        area: "Member List",
        direction: this.ts_map[key]
      });
    } else {
        console.log(`${key} is not a valid key in the map.`);
    }
  }

  brokerClickPagination(event: any){
    if(event.srcElement.parentElement.ariaLabel != null){
      window.dataLayer.push({'event': 'broker_click', 'click_location': 'Members Table', 'click_action': `Pagination - ${event.srcElement.parentElement.ariaLabel}`})
    }
   }

  handleGtagClick(click_location: string, click_action: string): void {
    window.gTagPush(click_location, click_action)
  }
}
